import{t as e}from"./index-a43cff1e.js";import{_ as o}from"./index-c9a2c887.js";import"./_rollupPluginBabelHelpers-ef57da83.js";import"emotion";export default function(r){return o(e(r))}
